const d = {
    CustomEvent: "ce",
    Pr: "p",
    mc: "pc",
    Cc: "ca",
    Al: "i",
    ul: "ie",
    Zt: "cci",
    ts: "ccic",
    Mt: "ccc",
    Vt: "ccd",
    Iu: "ss",
    Du: "se",
    $i: "si",
    Fi: "sc",
    Oi: "sbc",
    yc: "sfe",
    Go: "iec",
    dc: "lr",
    cc: "uae",
    vc: "lcaa",
    gc: "lcar",
    Gn: "inc",
    Rn: "add",
    On: "rem",
    $n: "set",
    Bn: "ncam",
    bc: "sgu",
    yr: "ffi",
    ro: "bi",
    ct: "bc",
  },
  Ee = { Mc: "content_cards_displayed" };
export { d as EventTypes, Ee as InternalEventTypes };
